import React from "react";
import Image from "next/image";
import Link from "next/link";
import PropTypes from "prop-types";

import { ASSETS_URL } from "configs/constant";

import { formatDate } from "@utils/helpers/formatDate";
import { formatImage } from "@utils/helpers/logic/image";

import newsItem from "@public/images/image-news-3.png";

const NewsItem = ({ title, type, dateTime, src, slug }) => {
  return (
    <div className="news-item">
      <Link href={`/news/${slug}`}>
        <a>
          <div className="news-item__image">
            <Image
              src={
                src?.length > 0 ? `${ASSETS_URL}/${formatImage(src)}` : newsItem
              }
              alt="image"
              layout="fill"
              objectFit="cover"
            />
          </div>
        </a>
      </Link>

      <div className="news-item__info">
        <span className="news-item__info__type">{type}</span>
        <span className="news-item__info__date">
          {formatDate(dateTime, "DD/MM/YYYY")}
        </span>
      </div>
      <Link href={`/news/${slug}`}>
        <p className="news-item__title">{title}</p>
      </Link>
    </div>
  );
};

NewsItem.propTypes = {
  tilte: PropTypes.string,
  type: PropTypes.string,
  dateTime: PropTypes.string,
  src: PropTypes.array,
  slug: PropTypes.string,
};

NewsItem.defaultProps = {
  tilte: "title",
  type: "Xu hướng",
};
export default NewsItem;
